// extracted by mini-css-extract-plugin
export default {"container":"articles_container__xacHc","header":"articles_header__fQVei","desc":"articles_desc__s1oGH","articles":"articles_articles__NPcky","article":"articles_article__tUgqx"};